import { useQuery } from "@tanstack/react-query";

import { getGetPracticeTimeZoneQueryKey, getPracticeTimeZone } from "@/api/orval/platform/platform";

/**
 * The practice's time zone for showing promotional expiry dates on its calendar: a time zone id, null
 * when the practice has none because its locations span more than one, or undefined until it has
 * loaded. Fetched only when `isNeeded`, so screens with nothing expiring make no request.
 */
export const usePracticeTimeZone = (isNeeded: boolean): string | null | undefined => {
  const { data } = useQuery({
    queryKey: getGetPracticeTimeZoneQueryKey(),
    queryFn: ({ signal }) => getPracticeTimeZone(undefined, undefined, signal),
    enabled: isNeeded,
    staleTime: Infinity,
  });

  return data?.timeZoneId;
};
